import xlsxExport from '../../shared/xlsxExport/xlsxExport';
import { SheetExportTypes } from '@common/xlsxExport/xlsxExport.constants';
import { obligationColumnDefinitionForExport } from '../../shared/columnDefinitions/obligations';
import { sortBySeverity } from '../../shared/sortBySeverity';

export default ({
  periodName,
  obligations,
  hideDecimals,
  negativeMinus,
  shouldDisplayZero,
  environmentSuffix,
}) => {
  const dataWithPeriods = obligations.map(row => ({
    periodName,
    ...row,
  })).sort(sortBySeverity);

  const sheetData = [
    {
      name: 'Obligations',
      type: SheetExportTypes.GRID,
      columnDefinitions: obligationColumnDefinitionForExport,
      data: dataWithPeriods,
      options: {
        hideDecimals,
        negativeMinus,
        shouldDisplayZero,
      },
    },
  ];

  xlsxExport({
    sheetData,
    metadata: {
      fileName: `TLS_Obligations_${periodName}${environmentSuffix}`,
      disableHeaderRendering: true,
    },
  });
};
